import { createSlice } from '@reduxjs/toolkit';
import type { Badge } from '@wix/ambassador-badges-v3-badge/types';

import type { Reducer } from '../../types';

export interface BadgesState {
  list: Badge[];
}

export type SetBadgeListPayload = BadgesState;

const name = 'badges';

const initialState: BadgesState = { list: [] };

const setBadgeList: Reducer<BadgesState, SetBadgeListPayload> = (
  state,
  { payload },
) => ({
  ...state,
  list: payload.list,
});

const reducers = { setBadgeList };

const badgesSlice = createSlice({ name, initialState, reducers });

export default badgesSlice;
